import type { FC } from 'react';
import RenderLayout, { type LayoutComponentType } from './RenderLayout';
import RenderTile from './RenderTile';

const renderComponentTypes = {
    layout: RenderLayout,
    tile: RenderTile
};

type RenderDynamicProps = {
    config?: {
        _type: `layout/${LayoutComponentType}` | `tile/${LayoutComponentType}`;
    };
    isLoading?: boolean;
};

const RenderDynamic: FC<RenderDynamicProps> = ({ config, isLoading = false }) => {
    try {
        const [type] = config?._type.split('/') ?? [];
        const DynamicComponent = renderComponentTypes[type as keyof typeof renderComponentTypes];

        // We're missing required props for RenderTile, but it's unclear whether this is ever called for a tile.
        // @ts-expect-error
        return <DynamicComponent config={config} isLoading={isLoading} />;
    } catch (e) {
        if (import.meta.env.DEV) {
            // eslint-disable-next-line no-console
            console.error('Error rendering dynamic component:', e);
        }
        return (
            <div className='p-3 rounded bg-statusErrorPrimary'>
                <span className='font-bold'>Error:</span> Something went wrong during render.
            </div>
        );
    }
};

export default RenderDynamic;
